import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import LinkBtn from "../common/link-btn"
import clsx from "clsx"

export default function CardSection({ data }) {
  return (
    <div className="fadein-up">
      <div className="relative overflow-hidden rounded-[45px] md:rounded-[80px] px-6 md:px-20 py-14 md:py-[74px] md:min-h-[640px] flex shadow-[7px_5px_24px_0_rgba(0,0,0,0.25)] transition-all duration-300">
        <div className="absolute inset-0 -z-[1]">
          <GatsbyImage
            alt="background image"
            image={getImage(data.backgroundImage.gatsbyImageData)}
            className="object-cover w-full h-full [&_img]:rounded-[45px] md:[&_img]:rounded-[80px]"
          />
        </div>

        <div
          className={clsx(
            "max-w-[700px] flex flex-col justify-between",
            data.position === "left" ? "text-left" : "text-right ml-auto"
          )}
        >
          <div>
            <div className="text-sm uppercase text-primary">
              {data.subheading}
            </div>
            <h2 className="mt-3 heading card-section-h" dangerouslySetInnerHTML={{__html: data.heading}}></h2>
            <div
              className={clsx(
                "mt-8 max-w-[500px] article-style description flex flex-col",
                data.position === "left"
                  ? "text-left"
                  : "text-right ml-auto items-end"
              )}
              dangerouslySetInnerHTML={{ __html: data.description }}
            ></div>
          </div>

          {data.link && (
            <div className="mt-6">
              <LinkBtn link={data.link} className="fill" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
